import { getAgentColor } from '../../utils/agents';
import type { AgentWithCount } from '../../types/agents';

function getInitials(name: string): string {
  const parts = name.split(' ');
  if (parts.length === 1) return name.substring(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

interface AgentCardProps {
  agent: AgentWithCount;
  onClick: () => void;
}

export default function AgentCard({ agent, onClick }: AgentCardProps) {
  const colorClass = getAgentColor(agent.department);
  const initials = getInitials(agent.name);

  return (
    <div
      className="bg-bg-secondary border border-border-subtle rounded-lg p-4 hover:border-border-hover hover:scale-[1.02] cursor-pointer transition-all duration-150"
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick();
        }
      }}
    >
      <div className="flex items-start gap-3">
        <div className={`w-9 h-9 rounded-full ${colorClass} flex items-center justify-center flex-shrink-0`}>
          <span className="text-xs font-bold text-white">{initials}</span>
        </div>

        <div className="min-w-0 flex-1">
          <h3 className="text-sm font-semibold text-text-primary truncate">{agent.name}</h3>
          <p className="text-xs text-text-muted truncate">{agent.title}</p>

          <div className="flex items-center gap-2 mt-2">
            <span className={`inline-block px-1.5 py-0.5 rounded text-[10px] font-medium text-white ${colorClass}`}>
              {agent.isCSuite ? 'C-Suite' : agent.department}
            </span>
            {agent.skills.length > 0 ? (
              <span className="text-[10px] text-text-muted">
                {agent.skills.length} skill{agent.skills.length !== 1 ? 's' : ''}
              </span>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
